import { apiClient } from "../apiClient";

const DANH_SACH_NGANH_2_ENDPOINT = 'danh-sach-nganh-2';
export const danhSachNganh2Api = {
    SelectAll: () => apiClient.get(`${DANH_SACH_NGANH_2_ENDPOINT}`),
}